export default {
    distributors: [],
    totalDataRow:0
}
  